import { Box, Typography } from "@mui/material";
import Header from "../../components/layouts/Header/OverviewHeader";
import Footer from "../../components/layouts/Footer/OverviewFooter";
import * as styles from "./impressumStyles";

const Impressum: React.FC = () => {
    return (
        <Box sx={styles.pageContainer}>
            <Header />

            <Box sx={styles.contentContainer}>
                <Typography variant="h1" sx={styles.pageTitle}>
                    Impressum
                </Typography>

                <Box sx={styles.section}>
                    <Typography variant="body1" sx={styles.paragraph}>
                        consider it GmbH
                        <br />
                        Wilma-Witte-Stieg 1<br />
                        22047 Hamburg
                    </Typography>

                    <Typography variant="body1" sx={styles.paragraph}>
                        Handelsregister: 183571
                        <br />
                        Registergericht: Hamburg
                    </Typography>

                    <Typography variant="body1" sx={styles.paragraph}>
                        <strong>Vertreten durch:</strong>
                        <br />
                        Christopher Nigischer
                    </Typography>
                </Box>

                <Box sx={styles.section}>
                    <Typography variant="h2" sx={styles.sectionTitle}>
                        Kontakt
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Telefon: +4940228689110
                        <br />
                        E-Mail: hello@consider-it.de
                    </Typography>
                </Box>

                <Box sx={styles.section}>
                    <Typography variant="h2" sx={styles.sectionTitle}>
                        Umsatzsteuer-ID
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Umsatzsteuer-Identifikationsnummer gemäß § 27 a
                        Umsatzsteuergesetz:
                        <br />
                        DE276034969
                    </Typography>
                </Box>

                <Box sx={styles.section}>
                    <Typography variant="h2" sx={styles.sectionTitle}>
                        Verbraucherstreitbeilegung/Universalschlichtungsstelle
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Wir sind nicht bereit oder verpflichtet, an
                        Streitbeilegungsverfahren vor einer
                        Verbraucherschlichtungsstelle teilzunehmen.
                    </Typography>
                </Box>
            </Box>

            <Footer />
        </Box>
    );
};

export default Impressum;
